import styled, { css } from "styled-components";

import { breakpointsValuesV2 } from "@ui/themes/default";

import { RootProps, VariantKeys } from "./Icon.types";

export const IconWrapper = styled.div<RootProps>`
  ${({ $size, theme }) =>
    typeof $size === "string" &&
    css`
      width: ${theme.icons.sizes[$size]}px;
    `}

  ${({ $size, theme }) =>
    typeof $size === "object" &&
    Object.keys($size)
      .sort((aKey: VariantKeys, bKey: VariantKeys) => {
        if (aKey === "default") return -1;
        if (bKey === "default") return 1;

        return breakpointsValuesV2[aKey] - breakpointsValuesV2[bKey];
      })
      .map((breakpoint: VariantKeys) => {
        if (breakpoint === "default") {
          return css`
            width: ${typeof $size[breakpoint] === "number"
              ? $size[breakpoint]
              : theme.icons.sizes[$size[breakpoint]]}px;
          `;
        }

        if (!breakpoint) return;

        return css`
          ${theme.breakpointsV2[breakpoint]} {
            width: ${typeof $size[breakpoint] === "number"
              ? $size[breakpoint]
              : theme.icons.sizes[$size[breakpoint]]}px;
          }
        `;
      })}
`;
